import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { actionDockSetExpandFiles } from '@/modules/application/actions/dock';
import Expand from './Expand';
import ListItem from './ListItem';

const Files = (props) => {
    return (
        <>
            <ListItem title="Файлы" to="/files/"
                      onClick={(event) => {
                          event.preventDefault();
                          props.setExpand(!props.expand);
                      }}
            >
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    <ListItem title="Текстовые файлы" to="/files/text/"/>
                </List>
            </Collapse>
        </>
    );
};

export default connect(
    (state) => ({
        expand: state.dock.expandFiles,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandFiles, dispatch),
    })
)(Files);
